import type { FormControlLabelProps } from '@mui/material';
import { CheckedSvg } from '@/components/Icons/Checkbox/CheckedSvg';
import { UncheckedSvg } from '@/components/Icons/Checkbox/UncheckedSvg';
import { CheckboxBlock, CheckboxWrap } from './CheckboxField.styles';

export const CheckboxField = (props: Omit<FormControlLabelProps, 'control'>) => {
    return <CheckboxWrap {...props} control={<CheckboxBlock icon={<UncheckedSvg />} checkedIcon={<CheckedSvg />} />} />;
};
